import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import "../components/brands.css"

import YYP from "../images/YYP.png"
import YYAF from "../images/YYAF.jpeg"
import UNI from "../images/UNI.png"
import UDAHB from "../images/UDAHB.png"
import SHL from "../images/SHL.png"
import MERTR from "../images/MERTR.jpeg"
import MAMSB from "../images/MAMSB.jpg"
import MEDPRI from "../images/MEDPRI.png"
import ASIAIR from "../images/ASIAIR.png"
import DGHAL from "../images/DGHAL.png"
import SAPURA from "../images/SAPURA.svg"
import HEITECH from "../images/HEITECH.png"
import ARIES from "../images/ARIES.jpg"
import DIMDATA from "../images/DIMDATA.png"
import VTELE from "../images/VTELE.jpg"
import JARING from "../images/JARING.png"
import ISLIM from "../images/ISLIM.png"
import SPANCO from "../images/SPANCO.png"
import NEWPAR from "../images/NEWPAR.jpeg"
import MPOC from "../images/MPOC.png"
import UEM from "../images/UEM.png"
import MATRADE from "../images/MATRADE.png"
import INVSELANG from "../images/INVSELANG.png"
import MTDC from "../images/MTDC.png"
import ANTAH from "../images/ANTAH.jpg"
import GREENACRES from "../images/GREENACRES.png"
import UEMSUNRISE from "../images/UEMSUNRISE.png"

const BrandsWeWorkWith = () => (
  <Layout>
    <SEO title="Brands we work with" />
    <div className="brands-header-container">
      <h1 className="brands-header-title"> Brands We Work With</h1>
    </div>
    <div className="brands-main-content-alt">
      <div>
        <img
          src={ARIES}
          alt="Aries Telecoms"
          className="ARIES"
          width="138px"
          height="108px"
        ></img>
      </div>
      <div>
        <img
          src={ANTAH}
          alt="Antah Schindler"
          className="ANTAH"
          width="245px"
          height="112px"
        ></img>
      </div>
      <div>
        <img
          src={ASIAIR}
          alt="ASI Air Simpanan SDN BHD"
          className="ASIAIR"
          width="216px"
          height="108px"
        ></img>
      </div>
      <div>
        <img
          src={DGHAL}
          alt="Dagang Halal"
          className="DGHAL"
          width="192px"
          height="84px"
        ></img>
      </div>
      <div>
        <img
          src={DIMDATA}
          alt="Dimenstion Data"
          className="DIMDATA"
          width="216px"
          height="144px"
        ></img>
      </div>
      <div>
        <img
          src={GREENACRES}
          alt="Green Acres"
          className="GREENACRES"
          width="189px"
          height="81px"
        ></img>
      </div>
      <div>
        <img
          src={HEITECH}
          alt="Heitech"
          className="HEITECH"
          width="90px"
          height="90px"
        ></img>
      </div>
      <div>
        <img
          src={INVSELANG}
          alt="Invest Selangor"
          className="INVSELANG"
          width="185px"
          height="76px"
        ></img>
      </div>

      <div>
        <img
          src={ISLIM}
          alt="Islamic Liquidity Management"
          className="ISLIM"
          width="216px"
        ></img>
      </div>
      <div>
        <img
          src={JARING}
          alt="Jaring"
          className="JARING"
          width="216px"
          height="90px"
        ></img>
      </div>

      <div>
        <img
          src={MAMSB}
          alt="MAMSB"
          className="MAMSB"
          height="108px"
          width="96px"
        ></img>
      </div>
      <div>
        <img
          src={MATRADE}
          alt="MATRADE"
          className="MATRADE"
          width="150px"
          height="75px"
        ></img>
      </div>
      <div>
        <img
          src={MEDPRI}
          alt="Media Prima"
          className="MEDPRI"
          width="144px"
          height="84px"
        ></img>
      </div>
      <div>
        <img
          src={MERTR}
          alt="Merchantrade"
          className="MERTR"
          width="162px"
          height="81px"
        ></img>
      </div>
      <div>
        <img src={MPOC} alt="MPOC" className="MPOC" width="120px"></img>
      </div>
      <div>
        <img
          src={MTDC}
          alt="MTDC"
          className="MTDC"
          width="150px"
          height="72px"
        ></img>
      </div>
      <div>
        <img
          src={NEWPAR}
          alt="New Paradigm"
          className="NEWPAR"
          width="240px"
          height="66px"
        ></img>
      </div>
      <div>
        <img src={SAPURA} alt="Sapura" className="SAPURA" width="162px"></img>
      </div>
      <div>
        <img
          src={SHL}
          alt="SHL"
          className="SHL"
          width="84px"
          height="84px"
        ></img>
      </div>
      <div>
        <img
          src={SPANCO}
          alt="Spanco"
          className="SPANCO"
          width="240px"
          height="66px"
        ></img>
      </div>
      <div>
        <img
          src={UDAHB}
          alt="UDA Holdings Berhad"
          className="UDAHB"
          height="72px"
          width="168px"
        ></img>
      </div>
      <div>
        <img
          src={UEM}
          alt="UEM"
          className="UEM"
          width="123px"
          height="69px"
        ></img>
      </div>
      <div>
        <img
          src={UEMSUNRISE}
          alt="UEM Sunrise"
          className="UEMSUNRISE"
          width="155px"
        ></img>
      </div>
      <div>
        <img
          src={UNI}
          alt="Union Investment"
          className="UNI"
          width="240px"
        ></img>
      </div>
      <div>
        <img
          src={VTELE}
          alt="V Telecoms Malaysia"
          className="VTELE"
          width="228px"
        ></img>
      </div>
      <div>
        <img
          src={YYAF}
          alt="Yayasan Albukhary Foundation"
          className="YYAF"
          width="108px"
          height="108px"
        ></img>
      </div>
      <div>
        <img
          src={YYP}
          alt="Yayasan Peneraju Pendidikan Bumiputera"
          className="YYP"
          width="108px"
          height="108px"
        ></img>
      </div>
    </div>
  </Layout>
)
export default BrandsWeWorkWith
